import { schema } from '@rea-argonaut/actions';

export const getSeoSchema = (seoSchema?: string[] | null): string[] => {
  if (!seoSchema) return [];
  return seoSchema.map((s) => schema(JSON.parse(s) as Record<string, unknown>)).filter(Boolean);
};
